export default {
  img: {
    backgroundSize: '80%',
    backgroundColor: '#fff',
    backgroundRepeat: 'no-repeat'
  }
}
